export default {
  INVOKE: 'invoke',
  RPC_RESOLVE: 'rpc-resolve',
  RPC_REJECT: 'rpc-reject',
  API_DESCRIPTION: 'api-desc',
  INVOKE_FUNCTION: 'invoke-func',
  RESOLVE: 'resolve',
  REJECT: 'reject',
  REQUEST_API: 'request-api'
}